<template>
  <div :class="['haizol-nav', menuCollapseGetter ? 'collapse' : '']">
    <div class="inner-nav">
      <AgentEntry :href="homeUrl + '/agent-os'" :class="{'is-closed': menuCollapseGetter}" />
      <el-menu
        v-if="menuList.length"
        class="haizol-nav-menu"
        :default-active="activeMenu"
        @open="handleOpen"
        @close="handleClose"
        :collapse="menuCollapseGetter"
        :unique-opened="true"
        :collapse-transition="false"
      >
        <!-- :router="true" -->
        <!-- 第一级 -->
        <template v-for="item1 in menuList">
          <el-submenu
            class="el-submenu-lv1"
            v-if="item1.children && item1.children.length"
            :index="item1.name"
            :key="item1.name + '1-sub'"
          >
            <template slot="title">
              <span v-if="item1.meta.isFreeTrial" class="Intelligent-tip">{{item1.meta.freeTrialText || '限时免费体验'}}</span>
              <span v-if="item1.meta.svgIcon" class="menu-svg-icon menu-sub-icon" :style="getSvgIconStyle(item1.meta.svgIcon)"></span>
              <i v-else :class="`iconfont ${item1.meta?.icon || ''} menu-sub-icon`"></i>
              <span class="submenu-title" slot="title" v-if="item1.meta">{{
                item1.meta.title
              }}</span>
            </template>
            <!-- 第二级 -->
            <template v-for="item2 in item1.children">
              <el-submenu
                class="el-submenu-lv2"
                v-if="item2.children && item2.children.length"
                :index="item2.name"
                :key="item2.name + '2-sub'"
              >
                <span class="submenu-title" slot="title" v-if="item2.meta">{{
                  item2.meta.title
                }}</span>
                <!-- 第三级 -->
                <template v-for="item3 in item2.children">
                  <!-- <el-submenu v-if="item3.children && item3.children.length" :index="item3.name" :key="item3.name + '3-sub'">
                    <span class="submenu-title" slot="title" v-if="item3.meta">{{ item3.meta.title }}</span>
                  </el-submenu> -->
                  <el-menu-item
                    @click="routerPush(item3)"
                    :index="item3.name"
                    :key="item3.name + '3-item'"
                  >
                    <router-link
                      v-if="item3.meta && !item3.meta.isExternal"
                      @click.native.stop="() => {}"
                      class="menu-link menu-link-lv3"
                      :to="{ name: item3.name }"
                      :target="item3.meta.newTab ? '_blank' : ''"
                    >
                      <span class="item-title">{{ item3.meta.title }}</span>
                    </router-link>
                    <a
                      :href="`${item3.path}`"
                      @click.stop="() => {}"
                      v-if="item3.meta && item3.meta.isExternal"
                      class="menu-link menu-link-lv3"
                      :target="item3.meta.newTab ? '_blank' : ''"
                    >
                      <span class="item-title">{{ item3.meta.title }}</span>
                    </a>
                  </el-menu-item>
                </template>
              </el-submenu>
              <el-menu-item
                v-else
                @click="routerPush(item2)"
                :index="item2.name"
                :key="item2.name + '2-item'"
              >
                <router-link
                  v-if="item2.meta && !item2.meta.isExternal"
                  @click.native.stop="() => {}"
                  class="menu-link menu-link-lv2"
                  :to="{ name: item2.name }"
                  :target="item2.meta.newTab ? '_blank' : ''"
                >
                  <span class="item-title">{{ item2.meta.title }} </span>
                </router-link>
                <a
                  :href="`${item2.path}`"
                  @click.stop="() => {}"
                  v-if="item2.meta && item2.meta.isExternal"
                  class="menu-link menu-link-lv2"
                  :target="item2.meta.newTab ? '_blank' : ''"
                >
                  <span class="item-title">{{ item2.meta.title }}</span>
                  <!-- 售后处理小红点 -->
                  <i
                    v-if="
                      item2.meta.mark === 10 &&
                      ($store.state.bubbles.supplier_deduction_num > 0 ||
                        $store.state.bubbles.supplier_refund_num > 0)
                    "
                    style="
                      position: relative;
                      top: -6px;
                      left: 4px;
                      background-color: red;
                      width: 6px;
                      height: 6px;
                      border-radius: 10px;
                    "
                  ></i>
                </a>
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item
            @click="routerPush(item1)"
            class="el-menu-item-lv1"
            v-else
            :index="item1.name"
            :key="item1.name + '1-item'"
          >
            <router-link
              v-if="item1.meta && !item1.meta.isExternal"
              @click.native.stop="() => {}"
              class="menu-link menu-link-lv1"
              :class="{'is-dashboard': item1.name === 'dashboard'}"
              :to="{ name: item1.name }"
              :target="item1.meta.newTab ? '_blank' : ''"
            >
              <span v-if="item1.meta.svgIcon" class="menu-svg-icon menu-link-icon" :style="getSvgIconStyle(item1.meta.svgIcon)"></span>
              <i v-else :class="`iconfont ${item1.meta?.icon || ''} menu-link-icon`"></i>
              <span class="item-title">{{ item1.meta.title }}</span>
            </router-link>
            <a :href="`${item1.path}`" @click.stop="()=>{}" v-if="item1.meta&&item1.meta.isExternal" class="menu-link menu-link-lv1" :target="item1.meta.newTab ? '_blank' : ''">
           
              <span v-if="item1.meta.svgIcon" class="menu-svg-icon menu-link-icon" :style="getSvgIconStyle(item1.meta.svgIcon)"></span>
              <i v-else :class="`iconfont ${ item1.meta?.icon || '' } menu-link-icon`"></i>
              <span class="item-title">{{ item1.meta.title }}
                <span v-if="item1.meta.isFreeTrial" class="Intelligent-tip">{{item1.meta.freeTrialText || '限时免费体验'}}</span>
                <i v-else-if="item1.meta.isNew" class="iconfont icon-Frame is-new-icon"></i></span>
            </a>
          </el-menu-item>
          <!-- 通过路由的方式（但没法右键打开） -->
          <!-- <el-menu-item v-else :index="item1.name" :route="{name: item1.name}" :key="item1.name + '1-item'">
            <div style="background: yellow">
              <i class="el-icon-menu"></i>
              <span slot="title" v-if="item1.meta">{{ item1.meta.title }}</span>
            </div>
          </el-menu-item> -->
        </template>
      </el-menu>
      <!-- 快捷入口 -->
      <!-- <QuickEntry /> -->
    </div>
    <!-- 收起、展开 -->
    <div class="expand-and-close">
      <!-- <a
        href="https://www.haizol.com//survey/8fad39e7-1ae5-4dce-bf93-c822b5df1279"
        :class="{ 'product-rate-box': true, 'is-opacity': menuCollapseGetter }"
        target="_blank"
      >
        <span class="product-rate-box-txt">产品体验反馈</span>
        <div class="product-rate-box-icon"></div>
      </a> -->
      <div class="expand-and-close-box">
        <div
          @click="CHANGE_MENU_OPEN"
          :class="[
            'expand-and-close-btn',
            menuCollapseGetter ? 'close' : 'open',
          ]"
        >
          <i class="iconfont icon-icon-shouqi"></i>
          <span>{{ menuCollapseGetter ? "展开" : "收起" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations,mapState } from "vuex";
// import QuickEntry from './quick-entry.vue';
import {getDeductionNum, getIssuesListNum } from "@/utils/api/orderMenuNum"
import { activeUser ,getBusinessModelApi} from '@/utils/api/common.js'
import { homeUrl } from "@/utils/config";
import AgentEntry from './agent-entry.vue';

const PRODUCT_SALE_BUSINESS_MODEL = 2;
const PRODUCT_ONLY_HIDE_MENU_NAMES = [
  "ecological-cooperation-zone",
  "supplier-order",
  "supplier-payment-manage",
  "product-case",
  "buyer",
  "customer-management",
];

export default {
  data() {
    return {
      homeUrl,
      menuList: [],
      otheLink: ["rfq-list", "matched-rfqs", "unread-list"],
      needHideMenu: new Set(),
    };
  },
  components: {
    // QuickEntry
    AgentEntry
  },
  watch: {
    signGetter: {
      handler(newVal, oldVal) {
        this.handleMenus()
        this.getActiveUser()
      },
      deep: true,
      immediate: false,
    },
    userInfo:{
      handler(newVal, oldVal) {
        if(newVal){
          this.getBrandBusinessModel()
        }
      },
      deep: true,
      immediate: false,
    }
  },
  computed: {
    ...mapGetters(["menuCollapseGetter", "signGetter"]),
    ...mapState(['userInfo']),
    activeMenu() {
      const route = this.$route;
      const { meta, name } = route;
      if (meta && meta.activeMenu) {
        return meta.activeMenu;
      }
      return name;
    },
  },
  methods: {
    ...mapMutations(["CHANGE_MENU_OPEN"]),
    routerPush(item) {
      // 判断一下是否为外部链接，是则菜单项的跳转就拦掉
      if (!item.meta || (item.meta && !item.meta.isExternal)) {
        this.$router.push({
          name: item.name,
          params: item.params, // 如果有参数需要传递
          query: item.query, // 如果有查询参数需要传递
        });
        console.log(item);
      }
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    getSvgIconStyle(icon) {
      return {
        maskImage: `url(${icon})`,
        WebkitMaskImage: `url(${icon})`,
      };
    },
    // 判断报价器菜单是否显示
   async getActiveUser(){
      const res = await activeUser()
        console.log(res);
        if (res.rspResult.bizCode === 200) {
          const betaStatus  = this.userInfo.userMemberInfoVo&& this.userInfo.userMemberInfoVo.categories?this.userInfo.userMemberInfoVo.categories.includes(11):false
          console.log(betaStatus);
          
          const { options: { routes } } = this.$router;
          if (!betaStatus) {
            this.needHideMenu.add('smart');
          }
          if (!this.userInfo?.showLogistics) {
            this.needHideMenu.add('transport');
          }
          if(!betaStatus || !this.userInfo?.showLogistics) this.judgeNeedHideMenu();
        }
    },  
    handleMenus(sign) {
      const { options: { routes } } = this.$router;
      const sourceRoutes = sign || routes;
      const filteredRoutes = this.needHideMenu.size > 0
        ? sourceRoutes.filter(item => !this.needHideMenu.has(item.name))
        : sourceRoutes;
      this.menuList = this.filterMenus(filteredRoutes);
 
      // 是否要根据<完成企业进件>后才给展示这几个交易在线的菜单  MKP-14789
      // if(!sign) {
      //   const willRemoveRouteNames = ['supplier-order', 'supplier-contract-manage', 'supplier-financial'];
      //   tempRoutes = tempRoutes.filter((route)=> {
      //     return !willRemoveRouteNames.includes(route.name)
      //   })
      // }
    },
    filterMenus(routes) {
      return routes
        .filter(
          (item) => item.path && item.name && item.meta && !item.meta.unMenu
        )
        .map((item) => {
          const _route = {
            path: item.path,
            name: item.name,
          };
          if (item.meta && item.meta.title) {
            // 当路由嵌套比较深时，中间的路由就别配置标题了，直接省略  不然会渲染在菜单里
            _route.meta = item.meta;
          }
          if (item.children && item.children.length) {
            _route.children = this.filterMenus(item.children) || [];
          }
          return _route;
        });
    },

    // 获取售后订单待确认气泡数（售后菜单小红点显示）
    async getSupplierDeductionNum() {
      const res = await getDeductionNum({});
      if (res.rspResult.bizCode === 200) {
        this.$store.commit("SET_DEDUCTION_NUM", res.data.pendingNum);
      }
    },
    async getSupplierRefundNum() {
      const res = await getIssuesListNum({});
      if (res.rspResult.bizCode === 200) {
        this.$store.commit("SET_REFUND_NUM", res.data.pending);
      }
    },
    async getBrandBusinessModel(){
      // 经营模式 1表示来图加工 2表示产品销售
      const res = await getBusinessModelApi({compAesId:this.userInfo.aesCompId})
      if(res.rspResult.bizCode === 200){
        const brandBusinessModel = res.data?.businessModel
        if(brandBusinessModel?.length){
          const hasProductSale = brandBusinessModel.includes(PRODUCT_SALE_BUSINESS_MODEL);
          if(brandBusinessModel.length==1 && brandBusinessModel[0] == PRODUCT_SALE_BUSINESS_MODEL){
            this.needHideMenu.add("supplier");
            PRODUCT_ONLY_HIDE_MENU_NAMES.forEach(name => this.needHideMenu.add(name));
          }else if(!hasProductSale) {
            this.needHideMenu.add("topping");
            this.needHideMenu.add("supplier-product-opportunity-list");
          }
        }else {
          // 经营模式中不包含<产品销售>时，则隐藏"拓品管理"的菜单项 MKP-19412
          this.needHideMenu.add("topping");
          this.needHideMenu.add("supplier-product-opportunity-list");
        }
        this.judgeNeedHideMenu();
        this.$store.commit('SET_BRAND_BUSINESS_MODEL',brandBusinessModel || [])
      }
    },

    judgeNeedHideMenu() {
      // 集中过滤
      // - 把需要过滤的菜单所对应的路由name加入Set中，再在此处过滤
      this.handleMenus();
    }
  },
  created() {
    this.handleMenus(); //根据路由过滤出菜单 
    this.getSupplierDeductionNum()
    this.getSupplierRefundNum()
    
  }
}
</script>

<style lang="scss" src="@/assets/css/layout/nav.scss" scoped></style>
<style lang="scss" scoped>
.expand-and-close {
  width: 100%;
  // height: 44px;
  // border-top: 1px solid #E5E8ED;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  .product-rate-box {
    display: block;
    width: 134px;
    height: 32px;
    background-image: linear-gradient(
      180deg,
      rgba(87, 159, 253, 0.1) 0%,
      rgba(50, 132, 241, 0.1) 100%
    );
    border-radius: 18.5px;
    margin: 0 auto 16px;
    position: relative;
    cursor: pointer;
    transition: all 0.35s;
    &.is-opacity {
      opacity: 0;
      transform: translateX(-100%);
    }
    &-txt {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 12px;
      color: #0a92f1;
      letter-spacing: 0;
      margin-left: 16px;
    }
    &-icon {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 40px;
      height: 40px;
      background: url("../../assets/image/rate.png") no-repeat center;
      background-size: 40px 40px;
    }
  }
  &-box {
    border-top: 1px solid #e5e8ed;
    height: 44px;
  }
  &-btn {
    width: max-content;
    height: 44px;
    line-height: 44px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #16181a;
    letter-spacing: 0;
    cursor: pointer;
    transition: margin-left 0.25s;
    .iconfont {
      color: #98a3b7;
      font-size: 14px;
      line-height: 44px;
    }
    span {
      margin-left: 9px;
    }
    &.open {
      margin-left: 29px;
    }
    &.close {
      margin-left: 6px;
      .iconfont {
        display: inline-block;
        transform: rotateY(180deg);
      }
    }
  }
}
</style>
